import React from 'react';
import { Layout } from '@/components/layout/Layout';
import { SEOHead } from '@/components/SEOHead';

interface Sub {
  name: string;
  purpose: string;
  data: string;
  region: string;
  transfer: string;
}

const subprocessors: Sub[] = [
  { name: 'Supabase (Singapore-headquartered, EU-region tenants)', purpose: 'Application database, authentication, file storage, edge functions', data: 'All Service data', region: 'EU (Frankfurt)', transfer: 'EU SCCs where applicable' },
  { name: 'OpenAI Ireland Ltd.', purpose: 'Large language model inference for drafting and summarisation', data: 'Prompts and selected context', region: 'EU / US', transfer: 'EU SCCs, zero-retention via API' },
  { name: 'Anthropic PBC', purpose: 'Backup LLM provider for drafting and summarisation', data: 'Prompts and selected context', region: 'US', transfer: 'EU SCCs, zero-retention via API' },
  { name: 'Google Ireland Ltd. (Gemini API)', purpose: 'LLM extraction of action items and CRM updates from meeting transcripts', data: 'Meeting transcripts and selected context', region: 'EU / US', transfer: 'EU SCCs, no-training via API' },
  { name: 'Resend (Bracket Software, Inc.)', purpose: 'Transactional email delivery', data: 'Recipient email, name, message metadata', region: 'US (EU residency on request)', transfer: 'EU SCCs' },
  { name: 'Stripe Payments Europe Ltd.', purpose: 'Payment processing and invoicing', data: 'Billing contact, payment metadata', region: 'EU / US', transfer: 'EU SCCs' },
  { name: 'Cloudflare, Inc.', purpose: 'CDN, DDoS protection, edge caching', data: 'IP, request metadata', region: 'Global edge', transfer: 'EU SCCs' },
  { name: 'Google Ireland Ltd. (Analytics 4)', purpose: 'Website analytics (consent-based)', data: 'Truncated IP, page views, device', region: 'EU', transfer: 'EU SCCs' },
];

const Subprocessors = () => {
  return (
    <Layout>
      <SEOHead
        title="Subprocessors - NoQ5.ai"
        description="The third-party subprocessors NoQ5 uses to deliver the Service, the data they process and the location of processing."
        canonicalUrl="https://noq5.ai/subprocessors"
      />
      <article className="container px-4 md:px-6 py-12 max-w-4xl mx-auto">
        <header className="mb-10">
          <p className="text-sm text-muted-foreground">Last updated: 25 April 2026</p>
          <h1 className="text-4xl md:text-5xl font-bold text-foreground mt-2">Subprocessors</h1>
          <p className="text-muted-foreground mt-3 max-w-2xl">
            NoQ5 engages a small number of carefully vetted subprocessors to deliver the Service. We sign
            data-processing agreements with each, including EU Standard Contractual Clauses where data is
            processed outside the EEA. Customers can subscribe to subprocessor-change notifications by
            emailing <a className="text-primary hover:underline" href="mailto:batiste@noq5.ai">batiste@noq5.ai</a>.
          </p>
        </header>

        <div className="overflow-x-auto rounded-2xl border border-border">
          <table className="w-full text-sm">
            <thead className="bg-muted/30 text-foreground">
              <tr>
                <th className="text-left p-4 font-semibold">Subprocessor</th>
                <th className="text-left p-4 font-semibold">Purpose</th>
                <th className="text-left p-4 font-semibold">Data</th>
                <th className="text-left p-4 font-semibold">Region</th>
                <th className="text-left p-4 font-semibold">Transfer mechanism</th>
              </tr>
            </thead>
            <tbody>
              {subprocessors.map((s) => (
                <tr key={s.name} className="border-t border-border">
                  <td className="p-4 font-medium text-foreground">{s.name}</td>
                  <td className="p-4 text-muted-foreground">{s.purpose}</td>
                  <td className="p-4 text-muted-foreground">{s.data}</td>
                  <td className="p-4 text-muted-foreground">{s.region}</td>
                  <td className="p-4 text-muted-foreground">{s.transfer}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mt-6 text-sm text-muted-foreground">
          We give at least 30 days' notice of new subprocessors. Customers may object on reasonable
          data-protection grounds.
        </p>
      </article>
    </Layout>
  );
};

export default Subprocessors;
